export const METRIC_TYPES = {
  SHIFT_DETAILS: 'shiftDetails',
  DAILY_TASKS: 'dailyTasks',
  PERFORMANCE_METRICS: 'performanceMetrics',
  ANNOUNCEMENTS: 'announcements',
} as const;

export const SECTION_TITLES = {
  SHIFT_DETAILS: 'Shift Details',
  DAILY_TASKS: 'Daily Tasks',
  PERFORMANCE_METRICS: 'Performance Metrics',
  ANNOUNCEMENTS: 'Announcements',
} as const;

export const DEFAULT_SHIFT_DETAILS = {
  start_time: '09:00 AM',
  end_time: '05:00 PM',
  section: 'Dining Area',
  specials: 'Grilled Salmon',
};

export const DEFAULT_DAILY_TASKS = [
  { description: 'Set up tables' },
  { description: 'Prep vegetables' },
  { description: 'Clean the dining area' },
];

export const DEFAULT_PERFORMANCE_METRICS = {
  serviceSpeed: '95%',
  customerFeedback: '4.8/5',
  salesSummary: '1500',
};

export const DEFAULT_ANNOUNCEMENTS = [
  { message: 'Staff meeting at 3 PM.' },
  { message: 'New menu items launching tomorrow.' },
];
